import router from "@/router";

export default {
  messaging: [
    {
      title: "The Messaging Hub",
      text: `Here you can message any of your clients quickly and easily. If you have already messages with your client, you simply need to click their name/image. To message a new client`
    },
    {
      title: "Why use messaging",
      text: `Using the message system within Habit has been shown to increase client engagement, momentum, and progress. A host of studies have shown that message based coaching is an effective method of coaching and can create significant client impact.`
    },
    {
      title: "Start a conversation",
      text: "To message a new client, click Start a Conversation and type the person’s name.",
      selector: ".search-clients"
    }
  ],
  clientDetail: [
    {
      title: "The Client Detail",
      text: "This page is designed to give you an in depth view of your clients are doing."
    },
    {
      title: "The Client Breakdown",
      text: "Breakdown will show you their overall average ratings on each pulse survey topic and their average ratings in the last 7 days. If they do not have a number (i.e., -- instead of a number), then they have not answered questions on that topic.",
      selector: ".client-breakdown"
    },
    {
      title: "Exercises",
      text: "The Current Daily Exercises shows you what exercises your client is currently working on and the details of the exercise. You can view their full exercise history by clicking the View Exercise History. If your client has not completed any exercises in a week, you will be notified that your client is struggling.",
      selector: ".daily-exercise"
    },
    {
      title: "Commitments",
      text: "You can assign your client a commitment using the New Commitment link. Commitments are actions that your client has decided to take. Many coaches use the commitment feature in their coaching to increase accountability and to remind their clients of their commitments.  (The difference between habits and commitments is that habits re-occur regularly and commitments are one time actions.)",
      selector: ".client-commitments"
    },
    {
      title: "Custom Habits",
      text: "Custom Habits are habits that your client has set up for themselves.",
      selector: ".client-habits"
    },
    {
      title: "Reflections",
      text: "Reflections show a word cloud of the most frequent words used by your client in their reflections. The bigger the word, the more often it is used. If the word cloud is blank, then your client has not completed enough reflections for this analysis. The word cloud should start forming after 5-10 solid reflections.",
      selector: ".client-reflections"
    },
    {
      title: "Filtering Reflections",
      text: "The word cloud can be filtered for additional insights. To filter the word cloud by date, use the “Last” drop down menu of the filter and select the desired time frame. To filter by a pulse survey score, use the “Where” drop down and select a number. The word cloud will then present all words used when the client used that number on their pulse survey. You can also examine the words used above or below a certain number. To do this, select the cut-off number with the “Where” drop down and then use the “And” drop down to select either above or below.",
      selector: ".word-cloud-filter"
    },
    {
      title: "Reflection History",
      text: "To view your client’s complete daily reflections, click on “View All Daily Reflections.",
      selector: ".reflection-history"
    },
    {
      title: "Goals",
      text: "Current Goals shows your client’s progress on their current goals from left (0% complete) to right (100% complete). You will receive a notification in your email when your client completes a goal or abandons a goal.",
      selector: ".client-goals"
    },
    {
      title: "Your Notes",
      text: "Your Most Recent Notes About Client are your coach's notes—the notes you take about your client. Your client cannot see these notes; they are private to you. You can add a new note by clicking “Take a Note” and view all your past notes by clicking 'View All Notes.'",
      selector: ".coach-notes"
    },
    {
      title: "Client's Notes",
      text: "Client’s Recent Notes are the notes that your client has made. You can see all of your clients’ notes unless they mark it private, in which case it is only visible to them.",
      selector: ".client-notes"
    },
    {
      title: "KPI's",
      text: "This section graphs your client’s progress on their KPIs (key performance indicators). Your client selects key measurements on their own and records their KPI progress in their reflection surveys. Click on a data point to view the reflection that was taken when they recorded that KPI.",
      selector: ".client-kpi"
    },
    {
      title: "Percentage of Completed Exercises",
      text: "Percent of Completed Exercises graphs your client’s progress completing their assigned exercises. This graph will help you spot habits that come easily to your client and habits that cause them to struggle.",
      selector: ".completed"
    },
    {
      title: "Reflection History",
      text: "This next section graphs your client’s responses to the pulse surveys. You can use this graph to spot trends and gain additional insights into your client’s journey. Click on a data point to show the reflection that accompanied that score. When your client scores 3 or below, two or more days in a row, you will be notified by email that your client is struggling.",
      selector: ".charts > .wellbeing-charts"
    },
    {
      title: "Reflection Customization",
      text: "You can customize the graphs to measure any topic that you desire. You change the graphs and the pulse survey questions in the Pulse Surveys page.",
      selector: ".charts > .wellbeing-charts"
    },
    {
      title: "Messaging",
      text: "Send your client a message by clicking “Send Client a message”. Your client is notified via email that they have a message from their coach. Using the message system within Habit has been shown to increase client engagement, momentum, and progress. A host of studies has shown that message based coaching is an effective method of coaching and can create significant client impact.",
      selector: ".client-messaging"
    }
  ],
  coachDashboard: [
    {
      title: "The Dashboard",
      text: "The Dashboard is a summary list of all your current clients. You can quickly see your clients momentum (how consistent they are on their exercises) and their pulse (how they rate themselves on the pulse surveys). To see more detail on an individual client, click on the client’s name."
    },
    {
      title: "A Demo User",
      text: "We set you up with a demo client so you can see how to use this part of Habit"
    },
    {
      title: "Momentum",
      text: "Momentum is a brief snap shot of the clients usage in the past week. It's display of how many exercises, and daily reflections they've done"
    },
    {
      title: "Pulse",
      text: "Pulse is a brief snap shot of this client has been reporting in the past 7 days. The lower they're reporting the lower their pulse will be"
    },
    {
      title: "Updating a client",
      text: "You can deactivate, or change a clients habit program here. But before you deactivate the client, lets took a peek in his detail page. Click on 'Ryan Darby' to view his detail page."
    },
  ],
  clientDash: [
    {
      title: "Home",
      text:
        "This is your home for your habits. See your current progress, view and edit your past notes, and " +
        "complete exercises."
    },
    {
      title: "Goals",
      text: "Goals are an important tool for creating long lasting habits. We recommend you create both long term goals and short term goals",
      selector: "#goals"
    },
    {
      title: "Daily Exercises",
      text: `You will receive regular exercises. These exercises come either from your coach or from the habits you create for yourself. Each time you complete an exercise, you will get a reward, such as funny memes, inspiring quotes, or you can donate some of our profits toward a charitable cause in the Create the Change campaign. You can choose your rewards in your settings page.`,
      selector: "#exercises"
    },
    {
      title: "Your Notes",
      text: `Taking notes on your journey is an important part of making progress and lasting change. You take general notes, notes on specific exercises, or notes on in your course work. You can review your notes at any time either in this dashboard or on the notes page.`,
      selector: "#notes"
    },
    {
      title: "Support",
      text: `
       Having an issue? Let us know. Our world class support has an average response time of less than 15 minutes.
      `,
      selector: "#support-btn"
    },
    {
      title: "Daily Reflections",
      text: `
      Another important step in your development journey is self-reflection. Head over to the Self Reflect page to learn more.
      `, 
      buttons: [{
          text: "Go",
          action: () => router.push("/daily-reflection")
        }
      ]
    }
  ],
  nav: [
    {
      title: "Home",
      text:
        "Your dashboard is your homebase for your habits. See your goal progress, complete new exercises, and " +
        "browse your past notes.",
      selector: "#client-home"
    },
    {
      title: "Self Reflect",
      text: "Take daily reflections of your progress",
      selector: "#self-reflect"
    },
    // check your progress
    {
      title: "Check your Progress",
      text:
        "See how far you've come! Use the Progress tab to see the numbers behind your progress.",
      selector: "#progress"
    },
    // past reflections
    {
      title: "Past Reflections",
      text: "Use this tab to see your past reflections.",
      selector: "#reflection-history"
    },
    // exercise history
    {
      title: "Exercise History",
      text:
        "See a list of exercises you've completed, including detailed views of each.",
      selector: "#exercise-history"
    },
    // your habits
    {
      title: "Your Habits",
      text:
        "Create and edit your own habits, record completion, and take notes just like with the habit exercises assigned to you by your coach.",

      selector: "#habits"
    },
    // notes
    {
      title: "Notes",
      text: "View and edit notes from the past",
      selector: "#note-history"
    },
    // courses
    {
      title: "Courses",
      text:
        "Find and complete coursework, with multimedia exercises. Take on a lesson-by-lesson basis, and see what exercises you have left to do!",
      selector: ".v-navigation-drawer > .v-list > div:nth-child(9)"
    }
  ],
  dailyReflection: [
    {
      title: "Daily Reflections",
      text: `
      People who regularly self-reflect are happier, more successful, and have more control over their lives. They show more grit and resilience to overcome problems and obstacles. Also, they experience less stress, anxiety, and depression. Reflections only take a few moments a day, but they yield incredible benefits. To get the most out of the Self Reflect feature, make sure you use it regularly. You will receive a notification to self reflect at the time of your choosing (you can adjust the days and times you receive reflections in your settings).  Try completing your first reflection and then head over to the Check Your Progress page to learn more about how these self reflections can help you on your journey.
      `
    }, 
  ],
  progress: [
    {
      title: "The Word Cloud",
      text: `It doesn't look like much now, but as you complete more reflections, words that you use most often will start becoming more apparent. You will start to see patterns in your successes and failures, your ups and downs, and your life as a whole. This self discovery will help you take control and shape your life.`,
      selector: "#word-cloud"
    },
    {
      title: "Key Performance Indicators",
      text:
      `Use Key Performance Indicators (KPIs) as a benchmark for any metric. When you add KPIs, you will be able to record your progress in your regular Self Reflection surveys. To add a new KPI, simply click "+ Key Measurements".`,
      selector: "#client-kpis"
    },
    {
      title: "Visual Progress",
      text: `As you continue to take notes, complete exercises, and follow up with reflections, your data will form into beautiful graphs and visualizations to help you better understand your journey and progress. This is an incredible tool for greater insights and accountability.`,
      selector: "#client-charts",
      side: "top"
    }
  ],
  clientHabits: [{
      title: "Your Habits",
      text: "You can create your own habits in this portal. These habits will be delivered to you when you choose and by the method you selected in your settings (i.e., notifications, emails, or text). You will be able to record completion and take notes on these habits in the same manner that you do with the habit exercises assigned to you by your coach."
    }
  ],
  habitPrograms: [
    {
      title: "Habit Programs",
      text: `This page will list all your habit programs. To create a new habit program, click the Create New Habit Program link. To edit an existing habit program, click on the habit program or the edit pencil next to the habit program.`
    },],
  habitTechOwnedHabitProgram: [
    {
      title: "Ever Green Habit Programs",
      text: "This Habit Program is owned, and maintained by Habit Tech. You can use it with your clients."
    },
    {
      title: "Duplicating a Habit Program",
      text: "You can duplicate a habit program by clicking the Copy button.",
      selector: "#copy-habit-program"
    }
  ],
  habitProgramDetail: [
    {
      title: "Habit Program",
      text: `To create a new habit program, start by naming it and designating how many exercises they should receive in a day. Next, decide whether you want to your clients to receive exercises from all areas of focus or let your client select just some of the available areas of focus from which to receive exercises. Finally, select which pulse survey that clients should receive in conjunction with this habit program.`
    },
  ],
  areaOfFocus: [
    {
      title: "Area Of Focus",
      text: `Areas of Focus are the different topics, or constructs, that your exercises are designed to strengthen.`,
      selector: '#areas-of-focus'
    }
  ],
  areaOfFocusCreation: [
    {
      title: "Area of Focus Creation",
      text: "To create an area of focus, give it a name, description, choose a color for the exercises and press save."
    },
  ],
  newAreaOfFocus: [{
    title: "Your first Area of Focus",
    text: "Well done! You've created your first area of focus. You can add exercises, or edit this area of focus by clicking the pencil button"
  }],
  areaOfFocusExerciseCreation: [
    {
      title: "Create a New Exercise",
      text: "To create a new exercise, click the Create a New Exercise button.",
      selector: "#create-new-exercise"
    }
  ],
  newExercise: [
    {
      title: "Title",
      text: "Titles are a quick way for you to identify exercises. They're not shown to clients.",
      selector: "#exercise-title"
    },
    {
      title: "Short Descriptions",
      text: "The short description are the very basic exercise description. They're always shown to clients, and displayed in all notifications.",
      selector: "#exercise-short-description"
    },
    {
      title: "Description",
      text: "A more detailed description of the exercise to complete.",
      selector: "#exercise-description"
    },
    {
      title: "How",
      text: "This gives a complete 'How To' to perform the exercise.",
      selector: "#exercise-how"
    },
    {
      title: "Why",
      text: "Let the client know why they're preforming the exercise. Self internalizing is important to behavior change",
      selector: "#exercise-why"
    },
    {
      title: "Time",
      text: "How long does this take normally take?",
      selector: "#exercise-time"
    },
    {
      title: "Linked Lesson",
      text: "If you have a course built and this exercise relates to a lesson in that course, you can provide a link to the appropriate lesson with the Linked Lesson dropdown.",
      selector: "#exercise-linked-lesson"
    },
    {
      title: "Buffer Time",
      text: "How many days between exercise creation and before they can do this exercise again.",
      selector: "#exercise-buffer"
    },
    {
      title: "Expiration time",
      text: "How many days does the client have to complete the exercise before they've missed it.",
      selector: "#exercise-length"
    }, 
    {
      title: "Always assign",
      text: "This exercise will always be assigned if available",
      selector: "#exercise-always"
    }, 
  ]
}